// @flow
//eslint-disable-next-line
import React from 'react'
import { useDispatch } from 'react-redux'

import { ContentDialog } from '../../../components'

import { dialogAction } from '../../../store/actions'
import { useTranslation } from '../../../hooks'
import { IMAGE_SRC, CONSTANTS } from '../../../utils'

function AppFooter() {
	const translate = useTranslation()
	const dispatch = useDispatch()

	const openTermsPopup = () => {
		dispatch(dialogAction.openDialog(CONSTANTS.POPUP_TYPE.TERMS))
	}

	const openPrivacyPopup = () => {
		dispatch(dialogAction.openDialog(CONSTANTS.POPUP_TYPE.PRIVACY))
	}

	return (
		<>
			<section className="footerWrap">
				<div className="container">
					<div className="footer-main">
						<img
							src={IMAGE_SRC.FOOTER_LOGO}
							alt=""
							onClick={() => window.open(process.env.REACT_APP_BSECURE_WEBSITE_URL, '_blank')}
						/>
						<ul>
							<li>
								<span onClick={openTermsPopup}>{translate('FOOTER.TERMS')}</span>
							</li>
							<li>
								<span onClick={openPrivacyPopup}>{translate('FOOTER.PRIVACY')}</span>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<ContentDialog />
		</>
	)
}

export default AppFooter
